// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2o53x","head":"ProcedureTableInfo_head__3Es8R"};